import axios from "axios";

const EventsService = {
  GetEmployeeBirthdayList: () =>
    axios.get("EmployeeDetails/GetEmployeeList"),
};

export default EventsService;
